import $$ from 'dom7';
import Framework7 from 'framework7/framework7.esm.bundle.js';

// Import F7 Styles
import 'framework7/css/framework7.bundle.css';

// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/font-awesome.min.css';
import '../css/app.css';
import '../css/locker.css';
import '../css/theme.css';
import '../css/kyc.css';
import '../css/auth.css';
// Import Cordova APIs
import cordovaApp from './cordova-app.js';
// Import Routes
import routes from './routes.js';
// Auth screens interaction layer (OTP boxes, password reveal, inline errors)
import initAuthUI from './auth.js';
// Backend compatibility layer (HTTP error codes, blocks, rate limits, device id)
import {
  installApiCompat,
  attachApp,
  getDeviceId,
  setCordovaDeviceId,
  reportDeviceInfo,
  refreshDeviceInfo,
  checkMaintenance,
  hideMaintenance,
} from './api.js';
// KYC status and wallet limits from each userinfo (gates Withdraw / Send money)
import { noteAccount } from './kyc.js';

/*
 * Wrap $.ajax before anything can fire a request. The backend now answers
 * failures with 4xx instead of 200, and without this every validation error
 * would reach the app as a transport failure. See api.js.
 */
installApiCompat();
getDeviceId();

var baseURL = "https://youpaywallet.com/";
const app_ver = '1.0.8'; // App version, update this for new releases
const environment = 'production'; // Set to 'production' for live environment, 'development' for testing
var app = new Framework7({
  root: '#app', // App root element
  id: 'app.youpaywallet.com', // App bundle ID
  name: 'YouPay Wallet', // App name
  theme: 'md', // Automatic theme detection
  //app pushstate
  view: {
    pushState: true,
    pushStateSeparator: '#!',
    pushStateOnLoad: true,
    preloadPreviousPage: false,
  },
  smartSelect: {
    closeOnSelect: true,
  },
  sheet: {
    closeByBackdropClick: false
  },
  // App root methods
  methods: {
    initImageUpload: function(box) {
      let uploadField = box.querySelector('.image-upload');
        
        uploadField.addEventListener('change', getFile);
      
        function getFile(e){
          let file = e.currentTarget.files[0];
          checkType(file);
        }
        
        function previewImage(file){
          let thumb = box.querySelector('.js--image-preview'),
              reader = new FileReader();
      
          reader.onload = function() {
            thumb.style.backgroundImage = 'url(' + reader.result + ')';
          }
          reader.readAsDataURL(file);
          thumb.className += ' js--no-default';
        }
      
        function checkType(file){
          let imageType = /image.*/;
          //var size=(file.size)/1000;
          if (!file.type.match(imageType)) {
            app.toast.show({
              text: 'This is not an Image!',
              closeTimeout: 3000,
            });
            throw 'This is not an image';
          } else if (!file){
            app.toast.show({
              text: 'No file found!',
              closeTimeout: 3000,
            });
            throw 'No file found';
          } else {
            previewImage(file);
          }
        }
    },
    initDropEffect: function(box) {
      let area, drop, areaWidth, areaHeight, maxDistance, dropWidth, dropHeight, x, y;
          
      // get clickable area for drop effect
      area = box.querySelector('.js--image-preview');
      area.addEventListener('click', fireRipple);
      
      function fireRipple(e){
        area = e.currentTarget
        // create drop
        if(!drop){
          drop = document.createElement('span');
          drop.className = 'drop';
          this.appendChild(drop);
        }
        // reset animate class
        drop.className = 'drop';
        
        // calculate dimensions of area (longest side)
        areaWidth = getComputedStyle(this, null).getPropertyValue("width");
        areaHeight = getComputedStyle(this, null).getPropertyValue("height");
        maxDistance = Math.max(parseInt(areaWidth, 10), parseInt(areaHeight, 10));
    
        // set drop dimensions to fill area
        drop.style.width = maxDistance + 'px';
        drop.style.height = maxDistance + 'px';
        
        // calculate dimensions of drop
        dropWidth = getComputedStyle(this, null).getPropertyValue("width");
        dropHeight = getComputedStyle(this, null).getPropertyValue("height");
        
        // calculate relative coordinates of click
        // logic: click coordinates relative to page - parent's position relative to page - half of self height/width to make it controllable from the center
        x = e.pageX - this.offsetLeft - (parseInt(dropWidth, 10)/2);
        y = e.pageY - this.offsetTop - (parseInt(dropHeight, 10)/2) - 30;
        
        // position drop and animate
        drop.style.top = y + 'px';
        drop.style.left = x + 'px';
        drop.className += ' animate';
        e.stopPropagation();
        
      }
    },
    initFileUpload: function() {
      var inputs = document.querySelectorAll( '.inputfile' );
        Array.prototype.forEach.call( inputs, function( input )
        {
          var label	 = input.nextElementSibling,
            labelVal = label.innerHTML;

          input.addEventListener( 'change', function( e )
          {
            var fileName = '';
            if( this.files && this.files.length > 1 )
              fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
            else
              fileName = e.target.value.split( '\\' ).pop();

            if( fileName )
              label.querySelector( 'span' ).innerHTML = fileName;
            else
              label.innerHTML = labelVal;
          });
        });
    },
    getPIN: function(pincode, success, error) {
      var settings = {
        "async": true,
        "crossDomain": true,
        "url": "https://pincode.p.rapidapi.com/",
        "method": "POST",
        "headers": {
          "x-rapidapi-host": "pincode.p.rapidapi.com",
          "x-rapidapi-key": "d52c228c20msh28eb4e495fba18ep1836f6jsn44bce943016f",
          "content-type": "application/json",
          "accept": "application/json"
        },
        "processData": false,
        "data": "{\"searchBy\":\"pincode\",\"value\":"+pincode+"}"
      }
      
      $.ajax(settings).done(function (response) {
        if(response.length === 0) {
          error("no places found");
        }
        else {
          success(response);
        }
      });
    },
    getJSON: function( url, callback) {
      $.getJSON(url, function(data) {
        callback(data);
      });
    },
    request: function( url, data, datatype, beforesend, success, error) {
      $.ajax({
        url: url,
        data: data,
        cache: false,
        dataType: datatype,
        type: 'POST',
        crossDomain : true,
        beforeSend: function() {
          beforesend();
        },
        success: function(_response){
          success(_response);
        },
        error: function(_error){
          error(_error);
        }
      });
    },
    post: function( url, data, datatype, beforesend, success, error) {
      $.ajax({
        url: url,
        data: data,
        cache: false,
        dataType: datatype,
        type: 'POST',
        mimeType: "multipart/form-data",
        contentType: false,
        processData: false,
        crossDomain : true,
        beforeSend: function() {
          beforesend();
        },
        success: function(_response){
          success(_response);
        },
        error: function(_error){
          error(_error);
        }
      });
    },
    getUserData: function(success, error) {
      $.ajax({
        url: baseURL+'app/php/ajaxAuthentication.php',
        data: {userinfo: true, token: localStorage.getItem('authToken'), 'uuid': localStorage.getItem('uuid')},
        cache: false,
        dataType: 'json',
        type: 'POST',
        crossDomain : true,
        beforeSend: function() {
        },
        success: function(_response){
          //every page init lands here, so the KYC level and wallet
          //limits are never more than one page old
          noteAccount(_response);
          success(_response);
        },
        error: function(_error){
        }
      });
    },
    getUserDataLocker: function(success, error) {
      $.ajax({
        url: baseURL+'app/php/lockers.php',
        data: {subscribeInfo: true, token: localStorage.getItem('authToken')},
        cache: false,
        dataType: 'json',
        type: 'POST',
        crossDomain : true,
        beforeSend: function() {
        },
        success: function(_response){
          success(_response);
        },
        error: function(_error){
        }
      });
    },
    getUserDataInvest: function(success, error) {
      $.ajax({
        url: baseURL+'app/php/invest.php',
        data: {investInfo: true, token: localStorage.getItem('authToken')},
        cache: false,
        dataType: 'json',
        type: 'POST',
        crossDomain : true,
        beforeSend: function() {
        },
        success: function(_response){
          success(_response);
        },
        error: function(_error){
        }
      });
    },
    getBank: function(success, error) {
      $.ajax({
        url: baseURL+'app/php/ajaxAuthentication.php',
        data: {getbank: true},
        cache: false,
        dataType: 'json',
        type: 'POST',
        crossDomain : true,
        beforeSend: function() {},
        success: function(_response){
          success(_response);
        },
        error: function(_error){
          error(_error);
        }
      });
    },
    getSettings: function(success, error) {
      $.ajax({
        url: baseURL+'app/php/ajaxAuthentication.php',
        data: {getSettings: true},
        cache: false,
        dataType: 'json',
        type: 'POST',
        crossDomain : true,
        beforeSend: function() {},
        success: function(_response){
          success(_response);
        },
        error: function(_error){
          error(_error);
        }
      });
    },
    random_color: function() {
      var letters = '0123456789ABCDEF';
      var color = '';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    addComma: function(x) {
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
  },
  // App routes
  routes: routes,
  // Input settings
  input: {
    scrollIntoViewOnFocus: Framework7.device.cordova && !Framework7.device.electron,
    scrollIntoViewCentered: Framework7.device.cordova && !Framework7.device.electron,
  },
  // Cordova Statusbar settings
  statusbar: {
    overlay: Framework7.device.cordova && Framework7.device.ios || 'auto',
    iosOverlaysWebView: true,
    androidOverlaysWebView: false,
  },
  on: {
    init: function () {
      var f7 = this;
      if (f7.device.cordova) {
        // Init cordova APIs (see cordova-app.js)
        cordovaApp.init(f7);
      }
    },
    //APP PAGE INIT
    pageInit: function () {
      var f7 = this;
      if (f7.device.cordova) {
        // Init cordova APIs (see cordova-app.js)
        cordovaApp.init(f7);
        //push notifications
        document.addEventListener('deviceready', OneSignalInit, false);
        function OneSignalInit() {
            // Uncomment to set OneSignal device logging to VERBOSE  
            // window.plugins.OneSignal.setLogLevel(6, 0);
            
            // NOTE: Update the setAppId value below with your OneSignal AppId.
            window.plugins.OneSignal.setAppId("99ff4514-ef4f-488b-b853-942b3209e23b");
            window.plugins.OneSignal.setNotificationOpenedHandler(function(jsonData) {
              console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
            });
            //Prompts the user for notification permissions.
              //    * Since this shows a generic native prompt, we recommend instead using an In-App Message to prompt for notification permission (See step 6) to better communicate to your users what notifications they will get.
              window.plugins.OneSignal.promptForPushNotificationsWithUserResponse(function(accepted) {
                console.log("User accepted notifications: " + accepted);
            });
            //on cordova the native hardware id wins over the browser
            //fingerprint api.js falls back to before deviceready fires
            var deviceID = setCordovaDeviceId(device.uuid) || device.uuid;
            window.plugins.OneSignal.setExternalUserId(deviceID);
            //console.log(deviceID);
        }
      }
      //disable view in windows
      if(environment == 'production') {
        if ($(window).width() > 600) {
          // $$('.page-content').empty();
          // $$('.page-content').append('<div class="block text-align-center">\
          // <i class="f7-icons text-color-red" style="font-size:100px">exclamationmark_triangle_fill</i>\
          // <div class="block-title" style="white-space: normal;">This site is not available in landscape mode, Please rotate your device to portrait mode for better experience!</div>\
          // </div>');
          // $$('.navbar').empty();
          // $$('.title').html('');
          // $$('.title-large-text').html('');
          // $$('.panel-open').empty();
        }
        $(window).resize(function() {
          windowResize()
        });
        //disable f12 and right click
        $(document).keydown(function (event) {
          if (event.keyCode == 123) { // Prevent F12
              return false;
          } else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) { // Prevent Ctrl+Shift+I        
              return false;
          }
        });
        $(document).on("contextmenu", function (e) {        
          e.preventDefault();
        });
      }
      /* Maintenance, from /app/php/settings.php (was a static settings.json
         nothing could change without an FTP session). Asked before the session
         check on purpose: during a blocking window the login call is exactly
         what will not work. */
      checkMaintenance(baseURL);

      /* Bound once on document: the screen lives outside any page, and the
         router never rebuilds it. */
      document.addEventListener('click', function (event) {
        var retry = event.target.closest && event.target.closest('.ypw-maint__retry');
        if (retry) {
          event.preventDefault();
          app.dialog.preloader('Checking...');
          checkMaintenance(baseURL, function (data) {
            app.dialog.close();
            if (!data) {
              app.toast.show({ text: 'Still unreachable, please try again.', closeTimeout: 3000 });
            } else if (!data.maintenance) {
              app.toast.show({ text: 'We are back. Thanks for waiting!', closeTimeout: 2500 });
            }
          });
          return;
        }
        var dismiss = event.target.closest && event.target.closest('.ypw-maint__dismiss');
        if (dismiss) {
          event.preventDefault();
          /* Only reachable while the API is still serving -- the button is
             hidden for a blocking window. */
          hideMaintenance();
        }
      });
      //app version
      $$('.app-version').html(app_ver);
      //copyright year, so it never goes stale on 1 January
      $$('.current-year').html(new Date().getFullYear());
      //re-register the device when the app build, OS or handset has changed
      //since the last report; a no-op string compare the rest of the time
      refreshDeviceInfo(baseURL+'/app/php/ajaxAuthentication.php', app_ver);
      //check if user is terminated
      f7.methods.getUserData(function(data) {
        if(data.status == 'blocked') {
          app.views.current.router.navigate({name: 'Home'});
          localStorage.removeItem('authToken');
          localStorage.removeItem('phone');
          localStorage.removeItem('isloggedIN');
          localStorage.removeItem('payment');
          app.popup.close('#profile-popup');
          $$('.login-link').attr('href','/login/');
          $$('.login-link').removeClass('logout');
          $$('.login-link').html('Login');
          $$('.profile-link').attr('href','/login/');
          $$('.profile-link').removeClass('popup-open');
          $$('.profile-link').removeAttr('data-popup');
          f7.toast.show({
            text: 'Your account is terminated and logged out from this device!',
            closeTimeout: 3000,
          });
        }
      });
      //logout
      $$(document).off('click', '.logout');
      $$(document).on('click', '.logout' ,function() {
        localStorage.removeItem('authToken');
        localStorage.removeItem('phone');
        localStorage.removeItem('isloggedIN');
        noteAccount(null);
        app.popup.close('#profile-popup');
        var router = app.views.current.router;
        router.navigate(router.currentRoute.url, {
          reloadCurrent: true,
          ignoreCache: true,
        });
        $$('.profile-link').attr('href','/login/');
        $$('.profile-link').removeClass('popup-open');
        $$('.profile-link').removeAttr('data-popup');
        f7.toast.show({
          text: 'Logged out from this device!',
          closeTimeout: 3000,
        });
      })
      //OTP verification
      $(document).off('click', '.acBTNotp');
      $(document).on('click','.acBTNotp',function(){
        if (!$$('#ac-otp')[0].checkValidity()) {
          console.log('Check Validity!');
        } else {
          OTPverification();
        }
      });
      function OTPverification() {
        var value = $$('#ac-otp').val();
        app.methods.request(
          baseURL+'/app/php/ajaxAuthentication.php',
          {OTPver: true, mobile: localStorage.getItem('phone'), OTP: value},
          'json',
          function() {app.dialog.progress('Loading...'); $$('.button').addClass('disabled');},
          function(data) {
            $$('.button').removeClass('disabled');
            app.dialog.close();
            if(data.status == 'success') {
              app.toast.show({
                text: 'Logged in successfully!',
                closeTimeout: 3000,
              });
              app.popup.close('.sheet-OTP--verification');
              localStorage.setItem('authToken', data.token);
              localStorage.setItem('isloggedIN', true);
              localStorage.setItem('country', data.country);
              localStorage.removeItem('phone');
              //register this device against the account that just signed in
              reportDeviceInfo(
                baseURL+'/app/php/ajaxAuthentication.php',
                data.token,
                app_ver
              );
              setTimeout(() => {
                var view = app.views.current;
                view.router.navigate('/');
                app.dialog.close();
              }, 1000);
            }
            else {
              app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
            }
          },
          function() {
            $$('.button').removeClass('disabled');
            app.dialog.close();
            app.toast.show({
                  text: 'No internet connection!',
                  closeTimeout: 3000,
                });
          }
        );
      }
      //resend otp
      $(document).off('click', '.resendOTPac');
      $(document).on('click', '.resendOTPac', function() {
        var type = $$(this).data('type');
          if(type == 'account') {
            var phone = localStorage.getItem('phone');
          } else if(type == 'forgetpass') {
            var phone = $$('#fp-username').val();
          } else {
            
          }
        app.methods.request(baseURL+'/app/php/ajaxAuthentication.php',
        {OTPresend: true, phone: phone, type: type},
        'json',
        function() {app.dialog.progress('Loading...'); $$('.button').addClass('disabled');},
        function(data) {
          $$('.button').removeClass('disabled');
          app.dialog.close();
          if(data.status == 'success') {
            app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
          }
          else {
            app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
          }
        },
        function() {
          $$('.button').removeClass('disabled');
          app.dialog.close();
          app.toast.show({
            text: 'Failed to Connect',
            closeTimeout: 3000,
          });
        }
        );
      });
      function windowResize() {
        // if ($(window).width() > 600) {
        //   $$('.page-content').empty();
        //   $$('.page-content').append('<div class="block text-align-center">\
        //   <i class="f7-icons text-color-red" style="font-size:100px">exclamationmark_triangle_fill</i>\
        //   <div class="block-title" style="white-space: normal;">This site is not available in landscape mode, Please rotate your device to portrait mode for better experience!</div>\
        //   </div>');
        //   $$('.navbar').empty();
        //   $$('.title').html('');
        //   $$('.title-large-text').html('');
        //   $$('.panel-open').empty();
        // } else {
        //   //location.reload();
        // }
      }
    },
  },
});
/* Lets api.js surface blocks, rate limits and expired sessions through the
   app's own dialogs/router */
attachApp(app);
initAuthUI(app);
/* PWA service worker register

   The worker is served from the site root on purpose. Registering it from
   /static/ (as this did) caps its scope at /static/, so it can never control
   the app at / -- the fetch handler simply never runs. Note also that the
   register() promise resolving only means the script was fetched; it says
   nothing about whether install succeeded, so the state is logged separately. */
function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;

  /* Cordova runs from file://, where service workers are unavailable and the
     packaged assets are already local -- there is nothing to cache. */
  if (window.cordova || location.protocol === "file:") return;

  /* The one setup a worker genuinely breaks is webpack-dev-server's hot
     reload: it serves the bundle from cache, so edits appear not to take
     effect. That is narrower than "development" -- a build-dev output served
     statically has no reload client and is a perfectly good way to test the
     PWA, so it registers normally.

     WEBPACK_SERVE is set by the "dev" script alone. module.hot cannot be used
     for this: HotModuleReplacementPlugin is enabled for every development
     build, so it is true for build-dev output as well.

     Set localStorage.swInDev = "1" to override and register under it anyway.

     Skipping register() is not enough on its own: a registration made by an
     earlier build survives in the browser and keeps updating itself against
     whatever the dev server happens to serve. So any existing one is torn
     down here, along with the caches it filled. */
  var forceInDev = false;
  try {
    forceInDev = window.localStorage.getItem("swInDev") === "1";
  } catch (err) {
    /* storage blocked; treat as not forced */
  }

  if (process.env.WEBPACK_SERVE && !forceInDev) {
    navigator.serviceWorker.getRegistrations().then(function (regs) {
      regs.forEach(function (reg) {
        reg.unregister();
        console.log("service worker unregistered under hot reload:", reg.scope);
      });
    });
    if (window.caches && caches.keys) {
      caches.keys().then(function (names) {
        names.forEach(function (name) {
          if (name.indexOf("youpay-wallet-") === 0) caches.delete(name);
        });
      });
    }
    console.log(
      'service worker skipped under hot reload; localStorage.swInDev = "1" to force it on'
    );
    return;
  }

  navigator.serviceWorker
    .register("service-worker.js", { scope: "./" })
    .then(function (reg) {
      var worker = reg.installing || reg.waiting || reg.active;
      if (worker) {
        worker.addEventListener("statechange", function () {
          console.log("service worker:", worker.state);
        });
        console.log("service worker registered, scope", reg.scope, "-", worker.state);
      }
    })
    .catch(function (err) {
      console.log("service worker not registered", err);
    });
}
if (document.readyState === "complete") registerServiceWorker();
else window.addEventListener("load", registerServiceWorker);
/* PWA add to home button */
var notificationWithButton = app.notification.create({
    cssClass: 'ypw-install',
    icon: '<img src="assets/icons/icon.png" alt="">',
    title: 'YouPay Wallet',
    subtitle: 'Install the app',
    text:
      '<span class="ypw-install__copy">Add it to your home screen for instant access to payments, recharges and transfers.</span>' +
      '<span class="ypw-install__actions">' +
        '<button type="button" class="ypw-install__later no-ripple" id="install-later">Not now</button>' +
        '<button type="button" class="ypw-install__cta no-ripple" id="install-pwa">Install</button>' +
      '</span>',
    closeButton: true,
    on: {
      close: function () {
        var pwaPromptDismissed = {
          dismissed: true,
          time: new Date().toLocaleString(),
        }
        localStorage.setItem('pwaPromptDismissed', JSON.stringify(pwaPromptDismissed));
        console.log('PWA prompt dismissed');
      },
    },
});
/* Services on the home grid and the /services/ catalogue that have no biller
   behind them yet. They carry data-service instead of a route, and answer the
   tap honestly rather than looking broken. Wiring one up means giving that
   tile a real href and removing its data-service attribute. */
document.addEventListener('click', function (event) {
  var tile = event.target.closest && event.target.closest('[data-service]');
  if (!tile) return;

  event.preventDefault();
  app.toast.show({
    text: tile.getAttribute('data-service') + ' is coming soon',
    closeTimeout: 1800,
  });
});

var defferedPrompt;

/* Bound once, on document, rather than on the button each time the prompt
   opens: beforeinstallprompt can fire more than once, and re-binding per open
   stacked a duplicate handler every time. Delegation also survives the
   notification being destroyed and re-rendered between opens. */
document.addEventListener('click', function (event) {
  var button = event.target.closest && event.target.closest('#install-pwa, #install-later');
  if (!button) return;

  event.preventDefault();

  if (button.id === 'install-pwa' && defferedPrompt) {
    defferedPrompt.prompt();
    defferedPrompt.userChoice.then(function (choiceResult) {
      console.log(choiceResult.outcome === 'accepted'
        ? 'User accepted the A2HS prompt'
        : 'User dismissed the A2HS prompt');
      defferedPrompt = null;
    });
  }

  /* close() records the dismissal through the notification's own close hook */
  notificationWithButton.close();
});

// Check if the app is already installed
function isAppInstalled() {
  return window.matchMedia('(display-mode: standalone)').matches || 
          window.navigator.standalone ||
          document.referrer.includes('android-app://');
}

// Check if user has previously dismissed the prompt
function hasDismissedPrompt() {
  //check if it's dismissed 1 hour ago
  const pwaPromptDismissed = localStorage.getItem('pwaPromptDismissed');
  if (pwaPromptDismissed) {
    const { dismissed, time } = JSON.parse(pwaPromptDismissed);
    if (dismissed) {
      const dismissedTime = new Date(time);
      const currentTime = new Date();
      const oneHour = 60 * 60 * 1000; // 1 hour in milliseconds
      // Check if the prompt was dismissed more than 1 hour ago
      if (currentTime - dismissedTime > oneHour) {
        // If more than 1 hour has passed, allow the prompt to be shown again
        localStorage.removeItem('pwaPromptDismissed');
        return false;
      }
      // If less than 1 hour has passed, do not show the prompt again
      return true;
    } else {
      return false;
    }
  }
  return false;
}
// Check if app is already installed on page load
if (isAppInstalled()) {
    console.log('App is already installed');
}
window.addEventListener("beforeinstallprompt", function (event) {
    event.preventDefault();
    defferedPrompt = event;
    console.log("beforeinstallprompt fired");
    //check if app is already installed
    // Show the notification with install button
    if(!hasDismissedPrompt() && !isAppInstalled()) {
      notificationWithButton.open();
    } else {
      console.log('PWA prompt dismissed or app already installed');
    }
});

window.addEventListener("appinstalled", function (event) {
    console.log("app installed");
    defferedPrompt = null;
    console.log("app installed", event);
});
